//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: () => ({
    weatherOptions: ['Zonnig', 'Half bewolkt', 'Bewolkt', 'Regen', 'Droog'],
    generalImpressionOptions: ['Goed', 'Matig', 'Slecht'],
    degreeOfEntry: ['Geen', 'Geregeld', 'Veel', 'Pleksgewijs'],
  }),
};
